<template>
  <div>
    <st_header_cop :default_index="''"></st_header_cop>
    <div class="index_page contanic_no_lock">
      <!--首页-->
      <el-carousel :interval="5000" arrow="always" :height="'78vh'">
        <el-carousel-item v-for="item in dataList" :key="item.id">
          <img :src="item.cover_url" height="auto" width="100%"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <st_footer_cop></st_footer_cop>
  </div> 
</template>

<script>
import st_header from "../components/header_main.vue"
import st_footer from "../components/footer.vue"
import { getContentPage } from '../utils/api'
export default {
  name:"index",
  components:{
    st_header_cop : st_header,
    st_footer_cop : st_footer,
  },
  data() {
    return {
      dataList:[],
    };
  },
  methods:{
    getData(){
      let that = this;
      that.load.$emit('loading', true);
      getContentPage({"content_type":"Banner","page":1,"size":6})
      .then(function(res){
        if(res.code===1000){
          that.dataList = res.data.list
          setTimeout(function(){
            that.load.$emit('loading', false);
          },1000)
        }else{
          console.error("error")
        }
      }).catch(function(err){
        console.log(err)
      })
    }
  },
  created(){
    this.getData();
  }

}
</script>

<style scoped lang="scss">
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  //background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  //background-color: #d3dce6;
}
.index_page{
  background: rgba(255,255,255,0);
  padding-left: 30px;
  padding-right: 30px;
}

.contanic{
  padding-top: 80px;
  height: 75vh;
}
.contanic_no_lock{
  padding-top: 80px;
  height: auto;
  min-height: 75vh;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue